module.exports = __webpack_public_path__ + "static/img/empty-data.f31f7d54.png";